export default __webpack_public_path__ + "static/media/design.aeff5c76.svg";